import React from "react";
import { createRoot } from "react-dom/client";
//import './index.css';
//import 'bootstrap/dist/css/bootstrap.min.css'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

import "./assets/styles/bootstrap.custom.css";
import "./assets/styles/index.css";

import FullVideosScreen from "./screens/FullVideoScreen";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route
        path="/gymSoftwarefullVideo"
        element={
          <FullVideosScreen videoUrl="https://www.youtube.com/embed/GSSQX-dERWk" />
        }
      />
      <Route
        path="/gymSoftwareVideoForAds"
        element={
          <FullVideosScreen videoUrl="https://www.youtube.com/embed/fdvT9D277kU" />
        }
      />
      <Route
        path="/qrAttendanceVideo"
        element={
          <FullVideosScreen videoUrl="https://www.youtube.com/embed/EFoWljQENVE" />
        }
      />
      <Route
        path="/customPackagesVideo"
        element={
          <FullVideosScreen videoUrl="https://www.youtube.com/embed/NupvTeJ3drc" />
        }
      />
      <Route
        path="/subsrenewaldeleteVideo"
        element={
          <FullVideosScreen videoUrl="https://www.youtube.com/embed/iVtz19zqhXk" />
        }
      />
      <Route
        path="/updateVideos"
        element={
          <FullVideosScreen videoUrl="https://www.youtube.com/embed/DM0Tl7AqD0M" />
        }
      />
    </Route>
  )
);

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
